/*global $, dataLayer*/
import moment from "moment";
import {
  PRODUCT_ADD_TO_CART_EVENT,
  PRODUCT_ADD_TO_LIST_EVENT,
  PRODUCT_IMPRESSION_EVENT,
  ADDON_PRODUCT_IMPRESSION_EVENT,
  PRODUCT_CLICK_EVENT,
  PRODUCT_FIRST_ADD_TO_CART_EVENT,
  FIRST_CLICK_EVENT,
  PDP_CLICK_THROUGH_EVENT,
} from "../../utilities/constants";

let trackingInitialized = false;

export default {
  created() {
    if (!trackingInitialized) {
      trackingInitialized = true;
      this.hasEventListeners = true;

      window.addEventListener("load", this.onWindowLoad);

      //add impressions as we scroll the page
      document.addEventListener("scroll", this.onScroll, { passive: true });

      //add impressions from carousels when clicking the next button
      $(".hup-slider__nav--next").on("click", this.gtmCarouselImpressions);
    }
  },
  unmounted() {
    if (this.hasEventListeners) {
      trackingInitialized = false;
      window.removeEventListener("load", this.onWindowLoad);
      document.removeEventListener("scroll", this.onScroll);
      $(".hup-slider__nav--next").off("click", this.gtmCarouselImpressions);
    }
  },
  computed: {
    gtmEvent() {
      if (this.$route) {
        return this.$route.meta.gtmEvent || "";
      }
    },
    isSearchPage() {
      return window.location.pathname === "/search/";
    },
  },
  methods: {
    onWindowLoad() {
      if (this.gtmEvent != "e_addOnsSearch") {
        this.gtmProductImpressions();
      }
      this.gtmCarouselImpressions();
    },
    onScroll() {
      this.gtmProductImpressions();
      this.gtmCarouselImpressions();
    },
    gtmClick(
      event,
      product,
      bucket,
      listname,
      quantity,
      buttonType,
      position,
      reco,
      options
    ) {
      //map the product information differently for cart items
      if (buttonType === "cart") {
        product.displayName = product.product.displayName;
        product.id = product.product.id;
        product.brand = product.product.brand;
        product.ownBrand = product.product.ownBrand;
      }
      //map the product information differently for cart items in cart history
      if (buttonType === "cartHistory") {
        product.displayName = product.product.displayName;
        product.id = product.product.productId;
      }

      //set the event
      var gtmEvent = event;

      //set the categories
      var gtmCategoryList = "";
      if (buttonType === "cart" || buttonType === "cartHistory") {
        gtmCategoryList = product.product.defaultLevelOneCategory.name || "";
      } else if (buttonType === "nonspa") {
        if (
          _.get(product, "defaultBreadCrumb[0].displayName", false) === "Shop"
        ) {
          product.defaultBreadCrumb.shift();
        }

        // Replace &amp; with &
        gtmCategoryList = product.defaultBreadCrumb
          .map((category) => category.displayName.replace("&amp;", "&"))
          .join("/");
      } else {
        gtmCategoryList = product.defaultLevelOneCategory.name || "";
      }
      //set the listname
      var gtmProductList = "";
      if (bucket === "orderAddOns") {
        gtmProductList = "add-ons:" + listname;
      } else {
        gtmProductList = listname;
      }

      //set the variant
      var gtmCustomerFriendlySize = "";
      if (buttonType === "cart") {
        gtmCustomerFriendlySize = product.sku.customerFriendlySize;
      } else if (buttonType === "cartHistory") {
        gtmCustomerFriendlySize =
          product.product.defaultSku.customerFriendlySize;
      } else {
        gtmCustomerFriendlySize = product.defaultSku.customerFriendlySize;
      }

      //set the price
      var gtmPrice = "";
      if (buttonType === "cart") {
        gtmPrice = product.priceInfo.listPrice.amount;
      } else if (buttonType === "cartHistory") {
        gtmPrice = product.product.defaultSku.priceInfo.listPrice.formatted.substr(
          1
        );
      } else {
        gtmPrice =
          product.defaultSku.priceInfo.priceType == "EACH" &&
          product.defaultSku.priceInfo.listPrice.listPriceAmountRounded
            ? product.defaultSku.priceInfo.listPrice.listPriceAmountRounded
            : product.defaultSku.priceInfo.listPrice.formatted.substr(1);
      }

      if (
        gtmEvent === PRODUCT_ADD_TO_CART_EVENT ||
        gtmEvent === "e_addOnAddToCart"
      ) {
        //override for addons
        if (bucket === "orderAddOns") {
          gtmEvent = "e_addOnAddToCart";
        }

        if (quantity === 0) {
          quantity = 1;
        }
      } else if (
        gtmEvent === PRODUCT_CLICK_EVENT ||
        gtmEvent === "e_addOnProductClick"
      ) {
        //override for addons
        if (bucket === "orderAddOns") {
          gtmEvent = "e_addOnProductClick";
        }
      } else if (
        gtmEvent === "e_productDetailView" ||
        gtmEvent === "e_addOnProductDetailView"
      ) {
        //override for addons
        if (bucket === "orderAddOns") {
          gtmEvent = "e_addOnProductDetailView";
        }
      }

      const preferenceAttributes = [];
      const preference = _.get(options, "preference", false);

      if (preference) {
        preferenceAttributes.push({
          preferenceId: preference.id,
          preferenceType: preference.text,
          preferenceQuantity: quantity,
        });
      }

      const sharedProductAttributes = {
        name: product.displayName || "",
        id: product.id || "",
        category: gtmCategoryList || "",
        brand: product.brand || "",
        variant: gtmCustomerFriendlySize || "",
        price: gtmPrice || 0.0,
        position: position,
        dimension26: product.ownBrand || false,
        preferenceAvailable: !!preference,
        preferenceSelected: !!(preference && preference.selected),
        preferenceAttributes: preferenceAttributes,
      };

      if (typeof dataLayer !== "undefined") {
        // 1. add to cart tracking
        if (
          gtmEvent === PRODUCT_ADD_TO_CART_EVENT ||
          gtmEvent === "e_addOnAddToCart"
        ) {
          dataLayer.push({
            event: gtmEvent,
            ...(this.isSearchPage && { searchEngine: "V0" }),
            ecommerce: {
              add: {
                actionField: { list: gtmProductList },
                products: [
                  {
                    ...sharedProductAttributes,
                    quantity: quantity || "",
                  },
                ],
              },
            },
          });

          // 2. Also push e_ProductClick/PRODUCT_CLICK_EVENT but Only push e_productClick if they are NOT on the PDP for the added product
          // Checks if the URL contains product-detail and product.id
          // for example https://heb.com/product-detail/h-e-b-cafe-ole-ground-espresso-decaf-dark-roast-coffee/1166062
          // And we only need to send e_ProductClick once per page load per product
          if (
            !(
              window.location.href.indexOf(product.id) > -1 &&
              window.location.href.indexOf("product-detail") > -1
            ) &&
            this.thisProductHasntAlreadyBeenClicked(product.id)
          ) {
            dataLayer.push({
              event: PRODUCT_CLICK_EVENT,
              ...(this.isSearchPage && { searchEngine: "V0" }),
              ecommerce: {
                click: {
                  actionField: {
                    list: gtmProductList,
                  },
                  products: [
                    {
                      ...sharedProductAttributes,
                      dimension25: "product add to cart", // Click Type: either “add to list”, “product Click” or “product add to cart”
                      dimension40: reco,
                    },
                  ],
                },
              },
            });
            this.$store.commit("profile/PUSH_CLICKED_PRODUCT_ID", product.id);
          }
        }

        //product add to list tracking
        else if (gtmEvent === PRODUCT_ADD_TO_LIST_EVENT) {
          dataLayer.push({
            event: PRODUCT_ADD_TO_LIST_EVENT,
            ...(this.isSearchPage && { searchEngine: "V0" }),
            products: [
              {
                ...sharedProductAttributes,
              },
            ],
          });

          // Also push a productClick when adding to list
          if (this.thisProductHasntAlreadyBeenClicked(product.id)) {
            dataLayer.push({
              event: PRODUCT_CLICK_EVENT,
              ...(this.isSearchPage && { searchEngine: "V0" }),
              ecommerce: {
                click: {
                  actionField: {
                    list: gtmProductList,
                  },
                  products: [
                    {
                      ...sharedProductAttributes,
                      dimension25: "product add to list", // Click Type: either “add to list”, “product click” or “product add to cart”
                    },
                  ],
                },
              },
            });
          }
          // Tell vuex that we've clicked this product so don't track it again
          this.$store.commit("profile/PUSH_CLICKED_PRODUCT_ID", product.id);
        }

        // product click tracking
        else if (
          (gtmEvent === PRODUCT_CLICK_EVENT ||
            gtmEvent === "e_addOnProductClick") &&
          this.thisProductHasntAlreadyBeenClicked(product.id)
        ) {
          dataLayer.push({
            event: gtmEvent,
            ...(this.isSearchPage && { searchEngine: "V0" }),
            ecommerce: {
              click: {
                actionField: { list: gtmProductList },
                products: [
                  {
                    ...sharedProductAttributes,
                    dimension25: "product click", // Click Type: either “add to list”, “product click” or “product add to cart”
                  },
                ],
              },
            },
          });
        }

        // Product-Detail-Page click-through tracking
        else if (
          gtmEvent === "e_productDetailView" ||
          gtmEvent === "e_addOnProductDetailView"
        ) {
          dataLayer.push({
            event: gtmEvent,
            ecommerce: {
              detail: {
                actionField: { list: gtmProductList },
                products: [
                  {
                    ...sharedProductAttributes,
                  },
                ],
              },
            },
          });
        }

        // Search Page Only: On First Add To Cart by product
        if (this.isSearchPage && _.get(options, "isFirstAddToCart", false)) {
          dataLayer.push({
            event: PRODUCT_FIRST_ADD_TO_CART_EVENT,
            searchEngine: "V0",
            ecommerce: {
              add: {
                actionField: { list: gtmProductList },
                products: [
                  {
                    ...sharedProductAttributes,
                  },
                ],
              },
            },
          });
        }

        // Search Page Only: On first product interaction.
        if (
          this.isSearchPage &&
          !this.$store.state.profile.firstSearchResultInteractionFired
        ) {
          dataLayer.push({
            event: FIRST_CLICK_EVENT,
            searchEngine: "V0",
            ecommerce: {
              click: {
                actionField: {
                  list: gtmProductList,
                },
                products: [
                  {
                    ...sharedProductAttributes,
                  },
                ],
              },
            },
          });
          this.$store.commit("profile/SET_FIRST_SEARCH_INTERACTION");
        }

        // PDP Click Through Tracking
        if (gtmEvent === PDP_CLICK_THROUGH_EVENT) {
          dataLayer.push({
            event: PDP_CLICK_THROUGH_EVENT,
            ecommerce: {
              click: {
                actionField: {
                  list: gtmProductList,
                },
                products: [
                  {
                    ...sharedProductAttributes,
                  },
                ],
              },
            },
          });
        }
      }
    },
    gtmClickCoupon(event, coupon, position) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: event,
          ...(this.isSearchPage && { searchEngine: "V0" }),
          coupon: {
            title: coupon.displayName,
            id: coupon.couponId,
            position: position,
            type: coupon.couponDisplayType,
          },
        });
      }
    },
    gtmShowTimeSlot(firstAvailableTimeSlot) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_TimeSelectionModalShown",
          hoursBeforeFirstSlot: this.getHoursInAdvance(firstAvailableTimeSlot),
        });
      }
    },
    gtmClickPayAtPickup(payAtPickupSelected) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_ClickPayAtPickup",
          payatpickup_selection: payAtPickupSelected,
        });
      }
    },
    /**
     * @param {*} paymentMethod 'creditDebitCard' or 'ebtCard'
     * @param {*} isSelected
     */
    gtmSelectPaymentMethod(paymentMethod, isSelected) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_SelectPaymentMethod",
          payment_type: paymentMethod,
          payment_selected: isSelected,
        });
      }
    },
    /**
     * @param {*} launchLocation 'checkout_payment' or 'checkout_commit'
     * @param {*} transactionType 'balance' or 'snapDebit'
     */
    gtmLaunchEbtPinPad(launchLocation, transactionType) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_LaunchEbtPinPad",
          pin_pad_type: transactionType,
          location_launched_from: launchLocation,
        });
      }
    },
    gtmEditEbtAmount() {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_EditEbtAmount",
        });
      }
    },
    /**
     * @param {*} paymentMethod 'creditDebitCard' or 'ebtCard'
     * @param {*} storeId
     */
    gtmAddPaymentMethod(paymentMethod, storeId) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_AddPaymentMethod",
          payment_type: paymentMethod,
          storeId: storeId,
        });
      }
    },
    gtmClickFavorBanner() {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({ event: "e_ClickFavorDeliveryBanner" });
      }
    },
    gtmClickTimeSlot(selectedTime, firstAvailableTimeSlot, position) {
      //splits the selectedTimeSlot because for some reason it's coming back with the date twice, so it's not a valid date format.
      var selectedTimeSlot = selectedTime.substr(selectedTime.indexOf(" ") + 1);

      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_TimeSelectionModal",
          hoursInAdvance: this.getHoursInAdvance(selectedTimeSlot),
          timeSlotPosition:
            this.getDaysInAdvance(selectedTimeSlot) +
            "|" +
            this.pluralize(position) +
            " slot",
          hoursBeforeFirstSlot: this.getHoursInAdvance(firstAvailableTimeSlot),
        });
      }
    },
    gtmLeaveAtDoor(event, location, alcoholInCart) {
      if (typeof dataLayer !== "undefined") {
        if (event === "e_DeliveryLocationChanged") {
          dataLayer.push({
            event: "e_DeliveryLocationChanged",
            deliveryLocation: location,
            cartHasAlcohol: alcoholInCart,
          });
        }
      }
    },
    // COVID: Remove once medical timeslot program is done
    gtmMedTimeslots(
      event,
      { modal, storeId, selectedTab, secondsSpent, hospitalName, role }
    ) {
      if (typeof dataLayer !== "undefined") {
        if (event === "e_MedTimeslotsLearnMore") {
          dataLayer.push({ event, from: modal });
        } else if (
          event === "e_MedTimeslotsYesButton" ||
          event === "e_MedTimeslotsDismissed"
        ) {
          dataLayer.push({
            event: event,
            selectedTab,
            storeId,
          });
        } else if (event === "e_MedRoleModalCancelled") {
          dataLayer.push({ event, secondsSpent });
        } else if (event === "e_MedRoleModalSubmitted") {
          dataLayer.push({
            event,
            secondsSpent,
            hospitalName,
            role,
          });
        }
      }
    },
    gtmRemoveOrderItem(orderId, product, price, quantity) {
      if (typeof dataLayer !== "undefined") {
        dataLayer.push({
          event: "e_removeFromOrder",
          ecommerce: {
            refund: {
              actionField: { id: orderId },
              products: [
                {
                  name: product.displayName,
                  id: product.productId,
                  category: product.defaultLevelOneCategory.name,
                  variant: product.defaultSku.customerFriendlySize,
                  price: price,
                  quantity: quantity,
                },
              ],
            },
          },
        });
      }
    },
    gtmProductImpressions() {
      var vm = this;
      if (typeof dataLayer !== "undefined") {
        //Gather all the products together that are not already tagged with gtm-impressed
        var products = $(".gtm-product:not(.gtm-impressed)");

        var gtmPayload = {};
        if (this.isSearchPage) {
          gtmPayload.searchEngine = "V0";
        }

        if (
          this.gtmEvent === "e_addOnsLanding" ||
          this.gtmEvent === "e_addOnsSearch"
        ) {
          gtmPayload.event = ADDON_PRODUCT_IMPRESSION_EVENT;
        } else {
          gtmPayload.event = PRODUCT_IMPRESSION_EVENT;
        }
        var impressions = [];

        if (products.length > 0) {
          $(products).each(function (i) {
            var inView = vm.isInViewport(this);
            if (inView) {
              // only track the products in viewport
              var productData = $(this)
                .children('script[type="application/ld+json"]')
                .text();
              var json = JSON.parse(productData);
              impressions.push(json);
              // mark products as viewed, so they aren't picked up again in scroll event
              $(this).addClass("gtm-impressed");
            }
          });
        }

        //push the impressions to the dataLayer
        if (impressions.length > 0) {
          gtmPayload.ecommerce = { impressions: impressions };
          dataLayer.push(gtmPayload);
        }
      }
    },
    gtmCarouselImpressions() {
      var vm = this;
      if (typeof dataLayer !== "undefined") {
        //Gather all the products together that are not already tagged with gtm-impressed
        var productCarousels = $(
          ".products .slick-slide[aria-hidden=false]:not(.gtm-impressed)"
        );

        var gtmPayload = {};
        if (
          this.gtmEvent === "e_addOnsLanding" ||
          this.gtmEvent === "e_addOnsSearch"
        ) {
          gtmPayload.event = ADDON_PRODUCT_IMPRESSION_EVENT;
        } else {
          gtmPayload.event = PRODUCT_IMPRESSION_EVENT;
        }
        var impressions = [];

        if (productCarousels.length > 0) {
          $(productCarousels).each(function (i) {
            var inView = vm.isInViewport(this.querySelector(".gtm-img"));
            if (inView) {
              // only track the products in viewport
              var productData = $(this)
                .find(".gtm-img")
                .children('script[type="application/ld+json"]')
                .text();
              var json = JSON.parse(productData);
              impressions.push(json);
              // mark products as viewed, so they aren't picked up again in scroll event
              $(this).addClass("gtm-impressed");
            }
          });
        }

        //push the impressions to the dataLayer
        if (impressions.length > 0) {
          gtmPayload.ecommerce = { impressions: impressions };
          dataLayer.push(gtmPayload);
        }
      }
    },
    isInViewport(elem) {
      var bounding = elem.getBoundingClientRect();
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    pluralize(n) {
      var s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },
    getDaysInAdvance(time) {
      //get the date-time of right now
      var now = moment().parseZone();
      //get the selected date-time
      var timeSlot = moment(time).parseZone();
      //get the difference between the two dates, disregarding time
      return timeSlot.startOf("day").diff(now.startOf("day"), "days");
    },
    getHoursInAdvance(time) {
      //get the date-time of right now
      var now = moment().parseZone();
      //get the selected date-time
      var timeSlot = moment(time).parseZone();
      //get the difference between the two dates
      var difference = moment(timeSlot, "DD/MM/YYYY HH:mm:ss").diff(
        moment(now, "DD/MM/YYYY HH:mm:ss")
      );
      //convert to a duration to calucalte days, hours and minutes
      var duration = moment.duration(difference);

      var gtmHours;
      var gtmMinutes;

      //convert days to hours if it's more than one day
      if (duration.days() > 0) {
        gtmHours = duration.hours() + duration.days() * 24;
      } else {
        gtmHours = duration.hours();
      }
      //round to the nearest 00 or 30 minute interval
      if (duration.minutes() > 30 && duration.minutes() <= 59) {
        gtmMinutes = "30";
      } else {
        gtmMinutes = "00";
      }

      return gtmHours + ":" + gtmMinutes;
    },
    thisProductHasntAlreadyBeenClicked(id) {
      var alreadyClickedProductIds = this.$store.state.profile
        .gtmClickedProductIds;
      return alreadyClickedProductIds.indexOf(id) === -1;
    },
  },
};
